import { Component, Inject, Vue } from 'vue-property-decorator';
import AccountService from '@/account/account.service';
import { namespace } from 'vuex-class';
import { VueHtmlToPaper } from '@/entities/report-insights/printf.report';

const appStoreState = namespace('appStore');
@Component({})
export default class DsNavbarGuest extends Vue {
  @Inject('accountService')
  private accountService: () => AccountService;

  @appStoreState.Mutation
  public setIsShowShareReport!: (payload: boolean) => void;

  @appStoreState.Mutation
  public setIsShowShareTopic!: (payload: boolean) => void;

  isLoadingUser = true;

  public get authenticated(): boolean {
    return this.$store.getters.authenticated;
  }

  created() {
    if (this.$route.meta.recap) {
      this.$route.meta.recap = true;
    }
  }

  mounted() {
    document.getElementById('container-block').style['overflow-y'] = null;
    this.accountService()
      .retrieveAccount()
      .finally(() => {
        this.isLoadingUser = false;
      });
  }

  async print() {
    await VueHtmlToPaper.print('contentToPrint', {});
  }

  downloadAsWord() {
    this.$root.$emit('downloadAsWord');
  }

  downloadReportAsPDF() {
    this.$root.$emit('downloadReportAsPDF');
  }

  setIsShow() {
    this.setIsShowShareReport(true);
    this.setIsShowShareTopic(true);
  }
}
